/**
 * Class MapUI
 */
export default class MapUI {
  constructor() {
    this.id = 'MapContent'
    return this.ui()
  }

  content() {
    return {
      template: `<div id="${this.id}MapBlock" style="width: ${document.body.offsetWidth - 270}px; height:${document.body.offsetHeight - 140}px"></div>`
    }
  }

  toolBar() {
    return {
      view: 'toolbar',
      id: `${this.id}Toolbar`,
      height: 40,
      css: 'onedeck_toolbar',
      elements: [
        {
          view: 'icon',
          icon: 'mdi mdi-marker',
          css: 'no_click'
        },
        {
          view: 'label',
          label: 'Новая зона',
          id: `${this.id}ToolbarLabel`
        },
        {},
        {
          view: 'button',
          id: `${this.id}BtnStart`,
          label: 'Нарисовать зону',
          width: 200
        },
        {
          view: 'button',
          id: `${this.id}BtnStop`,
          label: 'Закончить рисование',
          width: 200
        },
        {
          view: 'button',
          id: `${this.id}BtnClear`,
          label: 'Oчистить зону',
          width: 120,
          css: 'btnRed'
        },
        {
          view: 'button',
          id: `${this.id}BtnSave`,
          label: 'Сохранить',
          width: 120,
          css: 'btnGreen'
        },
        {
          view: 'button',
          id: `${this.id}BtnRegions`,
          label: 'Список зон',
          width: 120
        }
      ]
    }
  }

  ui() {
    return {
      container: 'content',
      view: 'layout',
      height: document.body.offsetHeight - 80,
      id: this.id,
      rows: [this.toolBar(), this.content()]
    }
  }
}
